import React from 'react';
import styled from 'styled-components';

const CarouselContainer = styled.div`
  overflow-x: hidden;
`;

const CarouselContent = styled.div.attrs(({ offset, currentPosition }) => ({
  style: {
    transform: `translateX(-${(offset || 100) * currentPosition}%)`,
  },
}))`
  display: flex;
  transition-duration: ${({ duration }) => `${duration || 700}ms`};
`;

const CarouselComponent = ({ offset, currentPosition, duration, children }) => (
  <CarouselContainer>
    <CarouselContent offset={offset} currentPosition={currentPosition} duration={duration}>
      {children}
    </CarouselContent>
  </CarouselContainer>
);

export default CarouselComponent;
